export default __webpack_public_path__ + "media/images/icons/avatar-round-3c537867d0b3ff3cc2f3fc0b8196e72f.svg";